import { Outlet } from 'react-router';

import { useProfile } from '~entities/user';

import { AccessDenied } from './AccessDenied';

export function AdminGuard() {
  const { profile } = useProfile();

  if (!profile?.isAdmin) {
    return <AccessDenied />;
  }

  return <Outlet />;
}
